var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.3186 3.27354C4.1161 3.49089 4 3.82569 4 4.26084V19.7337C4 20.1689 4.1161 20.5037 4.32625 20.7134L4.38115 20.7597L13.0509 12.09V11.8951L4.3735 3.22719L4.3186 3.27354Z",
    fill: "url(#paint0_linear_120_1880)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9352 14.9911L13.0435 12.0985V11.896L15.9361 9.00341L15.9986 9.04211L19.42 10.9866C20.3996 11.5387 20.3996 12.4486 19.42 13.0084L15.9986 14.9529C15.9977 14.9524 15.9352 14.9911 15.9352 14.9911Z",
    fill: "url(#paint1_linear_120_1880)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9975 14.9524L13.0432 11.9973L4.3186 20.7219C4.6372 21.0644 5.17361 21.1031 5.77301 20.7683L15.9975 14.9524Z",
    fill: "url(#paint2_linear_120_1880)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9975 9.04301L5.77301 3.23484C5.17451 2.89238 4.6372 2.93874 4.3186 3.28119L13.0423 11.9973L15.9975 9.04301Z",
    fill: "url(#paint3_linear_120_1880)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_120_1880",
    x1: 18.216,
    y1: -1.85722,
    x2: -0.49359,
    y2: 3.13149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047ED6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50E6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_120_1880",
    x1: 20.6959,
    y1: 11.9966,
    x2: 10.9963,
    y2: 11.9966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB705"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_120_1880",
    x1: 14.3885,
    y1: 13.6031,
    x2: 3.24143,
    y2: 32.3677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9414F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C193F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_120_1880",
    x1: 2.12091,
    y1: -1.87511,
    x2: 7.09369,
    y2: 6.50626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33C481"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61E3A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/playStore.9bf74a1043f8fd67b994f0a1cd0981c4.svg";
export { ForwardRef as ReactComponent };